import { useCallback } from 'react';
import Datetime, { DatetimepickerProps } from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import { Icon } from '../Icon';
import { TextField } from '../TextField';
import { Chip } from '../Chip';
import formatDate from '../../utils/formatDate';
import { commonStrings } from '../../constants';

type Props = DatetimepickerProps & {
  label?: string;
  require?: boolean;
  bold?: boolean;
  textSize?: `text-${string}`;
  error?: boolean;
  disabled?: boolean;
  inputClass?: string;
  format?: string;
};

export function DatePicker({
  label,
  bold,
  textSize,
  error,
  disabled,
  require,
  renderInput,
  inputClass = '',
  format = 'LL',
  ...otherProps
}: Props) {
  const customRenderInput = useCallback(
    (props: any, openCalendar: Function) => {
      return (
        <div
          className="relative w-full"
          onClick={() => !disabled && openCalendar()}
        >
          <TextField
            {...props}
            className={inputClass}
            error={error}
            name={''}
            value={formatDate(props.value, format)}
            onChange={() => {}}
            inputClass="py-2.5"
            readOnly
            disabled={disabled}
            prefix={
              <div className="pl-2.5">
                <Icon icon={'calendar'} />
              </div>
            }
          />
        </div>
      );
    },
    [error, format, inputClass, disabled]
  );

  return (
    <>
      {label && (
        <label
          className={`mb-2 block leading-6 ${
            bold ? 'font-bold' : 'font-medium'
          } ${textSize} ${error ? 'text-error' : 'text-neutral-600'}
					${disabled ? 'opacity-50' : ''}`}
        >
          {label}
          {require && (
            <Chip
              textColor="text-white"
              className="ml-4"
              padding="py-0.25 px-2"
              textSize="text-[10px]"
              filled
            >
              {commonStrings.required}
            </Chip>
          )}
        </label>
      )}
      <Datetime
        renderInput={renderInput || customRenderInput}
        timeFormat={false}
        {...otherProps}
      />
    </>
  );
}
